import { ModelBase } from "../shared/model.base";
import { Role } from "../roles/role.type";

export class User extends ModelBase {
    companyId: number;
    username: string = "";
    password: string = "";
    passwordCompare: string = "";
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    active: true;
    has2FA: boolean = false;
    auth_channel: number = 1;
    passwordChange: boolean = false;
    isNewUser?: boolean;
    currentPassword: string = "";

    roles: Array<Role>;

    constructor() {
        super();
    }
}
